// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Form_contactSection__Aa-zt {
  padding: 80px 5%;
  background-color: #f9f9f9; 
  width: 100%;
}

.Form_container__ggg8t {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 400px;
  align-items: center;
  gap: 60px;
}

.Form_partners__agf0T {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-bottom: 50px;
  grid-column: 1 / -1; 
}

.Form_partners__agf0T img {
  height: 90px;
  width: auto;
  transition: all 0.3s ease;
}

.Form_partners__agf0T img:hover {
  filter: grayscale(0%);
  opacity: 1;
}

.Form_formContent__AiHLd h2 {
  font-size: 36px;
  font-weight: 800;
  color: var(--textoNegro);
  text-align: center;
  margin-bottom: 15px;
}

.Form_formContent__AiHLd p {
  font-size: 18px;
  color: #555;
  text-align: center;
  margin-bottom: 40px;
}

.Form_form__MCyoe {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Form_formGroup__22nrf {
  display: flex;
  flex-direction: column;
}

.Form_formGroup__22nrf label {
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--textoNegro);
}

.Form_formGroup__22nrf input, .Form_formGroup__22nrf textarea {
  padding: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.Form_formGroup__22nrf input:focus, .Form_formGroup__22nrf textarea:focus {
  outline: none;
  border-color: var(--azul);
  box-shadow: 0 0 0 2px rgba(2, 171, 231, 0.2);
}

.Form_submitButton__KnIDk {
  background-color: var(--naranja);
  color: var(--textoBlanco);
  padding: 15px 30px;
  border-radius: 5px;
  font-weight: 700;
  font-size: 18px;
  border: none;
  cursor: pointer;
  width: 100%;
}

.Form_submitButton__KnIDk:hover {
  background-color: var(--azul);
}

/* ===== Imagen del Robot ===== */
.Form_robotContainer__QkoQa {
  display: flex;
  justify-content: center;
  align-items: center;
}

.Form_robotContainer__QkoQa img {
  max-width: 100%;
  height: auto;
}

/* ======================================= */
/* ===== MEDIA QUERY PARA RESPONSIVE ===== */
/* ======================================= */
@media (max-width: 900px) {
  .Form_container__ggg8t {
    grid-template-columns: 1fr; /* Una sola columna */
  }

  .Form_formContent__AiHLd h2 {
    font-size: 28px;
  }

  .Form_robotContainer__QkoQa {
    order: -1; /* Mueve el robot hacia arriba */
    margin-bottom: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Form.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,4CAA4C;AAC5C,4CAA4C;AAC5C,4CAA4C;AAC5C;EACE;IACE,0BAA0B,EAAE,qBAAqB;EACnD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS,EAAE,gCAAgC;IAC3C,mBAAmB;EACrB;AACF","sourcesContent":[".contactSection {\n  padding: 80px 5%;\n  background-color: #f9f9f9; \n  width: 100%;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  align-items: center;\n  gap: 60px;\n}\n\n.partners {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n  margin-bottom: 50px;\n  grid-column: 1 / -1; \n}\n\n.partners img {\n  height: 90px;\n  width: auto;\n  transition: all 0.3s ease;\n}\n\n.partners img:hover {\n  filter: grayscale(0%);\n  opacity: 1;\n}\n\n.formContent h2 {\n  font-size: 36px;\n  font-weight: 800;\n  color: var(--textoNegro);\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.formContent p {\n  font-size: 18px;\n  color: #555;\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.formGroup label {\n  font-weight: 600;\n  margin-bottom: 8px;\n  color: var(--textoNegro);\n}\n\n.formGroup input, .formGroup textarea {\n  padding: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.formGroup input:focus, .formGroup textarea:focus {\n  outline: none;\n  border-color: var(--azul);\n  box-shadow: 0 0 0 2px rgba(2, 171, 231, 0.2);\n}\n\n.submitButton {\n  background-color: var(--naranja);\n  color: var(--textoBlanco);\n  padding: 15px 30px;\n  border-radius: 5px;\n  font-weight: 700;\n  font-size: 18px;\n  border: none;\n  cursor: pointer;\n  width: 100%;\n}\n\n.submitButton:hover {\n  background-color: var(--azul);\n}\n\n/* ===== Imagen del Robot ===== */\n.robotContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.robotContainer img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* ======================================= */\n/* ===== MEDIA QUERY PARA RESPONSIVE ===== */\n/* ======================================= */\n@media (max-width: 900px) {\n  .container {\n    grid-template-columns: 1fr; /* Una sola columna */\n  }\n\n  .formContent h2 {\n    font-size: 28px;\n  }\n\n  .robotContainer {\n    order: -1; /* Mueve el robot hacia arriba */\n    margin-bottom: 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contactSection": `Form_contactSection__Aa-zt`,
	"container": `Form_container__ggg8t`,
	"partners": `Form_partners__agf0T`,
	"formContent": `Form_formContent__AiHLd`,
	"form": `Form_form__MCyoe`,
	"formGroup": `Form_formGroup__22nrf`,
	"submitButton": `Form_submitButton__KnIDk`,
	"robotContainer": `Form_robotContainer__QkoQa`
};
export default ___CSS_LOADER_EXPORT___;
